// src/components/StockMovementList.tsx
import React from 'react';
import { IonList, IonItem, IonLabel, IonBadge } from '@ionic/react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Box, Paper, Typography } from '@mui/material';
import { Movement } from '../../models/stocks';
// import { Movement } from '../models/Stock';

interface StockMovementListProps {
  movements: Movement[];
}

const columns: GridColDef[] = [
  //{ field: 'id', headerName: 'ID', width: 70 },
  { field: 'product_name', headerName: 'Item', width: 150 },
  //{ field: 'type', headerName: 'Type', width: 120 },
  { field: 'quantity', headerName: 'Qty', width: 100 },
  { field: 'fro_bra_name', headerName: 'From', width: 150 },
  { field: 'to_bra_name', headerName: 'To', width: 150 },
  { field: 'moved_at', headerName: 'Date', width: 180 },
  { field: 'reason', headerName: 'Reason', width: 150 },

  // { field: 'receiver_full_name', headerName: 'Request From', width: 150 },
  //   { field: 'approver_full_name', headerName: 'Approved By', width: 150 },

];

const StockMovementList: React.FC<StockMovementListProps> = ({ movements }) => {
  return (
    <Box sx={{ height: '100%', width: '100%', mt: 2 }}>
      <Typography variant="h6" gutterBottom>
        Recent Stock Movements
      </Typography>
      <Paper elevation={3} sx={{ p: 2 }}>
        <DataGrid
          rows={movements}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10, 20, 50]}
          checkboxSelection
          disableSelectionOnClick
        />
      </Paper>
    </Box>
  );
};

export default StockMovementList;